import { useNotifications } from '@ordo/notifications-client/react'
import { NotificationCenterPage, type NotificationTab } from '@ordo/ui/notification-center'
import { notificationCenterPropsFrom } from '@ordo/ui/notification-inbox'
import { useState } from 'react'

/** "See all" from the bell: the full unified inbox, read through Comms' `/api/notifications` proxy. */
export function Notifications() {
  const [tab, setTab] = useState<NotificationTab>('all')
  const inbox = useNotifications({ tab })
  return <NotificationCenterPage {...notificationCenterPropsFrom(inbox)} tab={tab} onTabChange={setTab} />
}
